module.exports = __webpack_public_path__ + "img/red_packet.aaa9395c.png";